import { List, Record } from 'immutable'
import { IRaceEthnicity, RaceEthnicity } from './RaceEthnicity'

export interface IRaceEthnicityBreakdown {
  readonly raceEthnicities: List<IRaceEthnicity>
  readonly year: number
  readonly imported: boolean
  readonly otherPercentage: number
}

const RaceEthnicityBreakdownRecord = Record({
  imported: false,
  otherPercentage: 0,
  raceEthnicities: List<RaceEthnicity>(),
  year: 0,
})

export class RaceEthnicityBreakdown extends RaceEthnicityBreakdownRecord
  implements IRaceEthnicityBreakdown {
  public static fromJS(initialState?: Partial<IRaceEthnicityBreakdown>) {
    if (!initialState) {
      return new RaceEthnicityBreakdown()
    }

    const { raceEthnicities, ...rest } = initialState

    return new RaceEthnicityBreakdown({
      raceEthnicities: raceEthnicities
        ? List(raceEthnicities.map((a) => RaceEthnicity.fromJS(a)))
        : undefined,
      ...rest,
    })
  }

  public readonly raceEthnicities: List<RaceEthnicity>
  public readonly year: number
  public readonly imported: boolean
  public readonly otherPercentage: number

  constructor(initialState?: Partial<RaceEthnicityBreakdown>) {
    initialState ? super(initialState) : super()
  }
}
